export default __webpack_public_path__ + "static/media/joseph-lubin.c717213c.jpeg";